import { render } from "./video.vue?vue&type=template&id=ad58165e&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=ad58165e&scoped=true&lang=css"

import exportComponent from "D:\\phpstudy_pro\\好好玩官网\\wan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad58165e"]])

export default __exports__